/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sankalp's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Sankalp Srivastava Portfolio",
    type: "website",
    url: "https://github.com/sankalp-srivastava/portfolio-website",
  },
};

//Home Page
const greeting = {
  title: "Sankalp Srivastava",
  logo_name: "Sankalp Srivastava",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://docs.google.com/document/d/1VuLWs_JWV1zk5teS-FNpM7E-XVTJw2gb/edit",
  githubProfile: "https://github.com/sankalp-srivastava",
  portfolio_repository: "https://github.com/sankalp-srivastava",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sankalpsrivastava-2605/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:raunaksrivastava22@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/sankalp_srivasv",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/sankalp__srivastava/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Creating application backend in Node, Express ",
        "⚡ Connecting application with MongoDB for seamless data storage",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "vscode-icons:file-type-mongo",
          style: {
            // color: "#663399",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
    {
      title: "Machine Learning & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for image predicition and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Sklearn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: {
            backgroundColor: "transparent",
            // color: "#",
          },
        },
        {
          skillName: "Kaggle",
          fontAwesomeClassname: "simple-icons:kaggle",
          style: {
            color: "#20beff",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/raunaksrivastav3",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/bat_chef",
    },
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://leetcode.com/raunaksrivastava22/",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@raunaksrivastava22",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/sankalpsrivastava26",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "JSS Academy of Technical Education, Noida",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "jsslogoicon.png",
      alt_name: "AKTU",
      duration: "2019 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
      ],
      website_link: "https://www.jssaten.ac.in/",
    },
    {
      title: "Sunbeam School Lahartara, Varanasi",
      subtitle: "PMC with Computer Science - Senior Secondary",
      logo_path: "sbs-logo.png",
      alt_name: "SBL",
      duration: "2018",
      descriptions: [
        "⚡ I have studied Physics, Chemistry and Mathematics with Computer Science.",
        "⚡ I scored 89% in CBSE Board Examination.",
      ],
      website_link: "http://sunbeamschools.com/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/29C7T6YUF2JN",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Machine Learning on GCP Specialiazation",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/4PWR4WDE4QZA",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Containers & Kubernetes Essentials",
      subtitle: "- IBM Developer skill network",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/a9c2f8fe-056b-4c9e-b278-67d85f8dc365?source=linked_in_profile",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },

    {
      title: "End to End ML with tensorflow on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/CY673R6A4XCP",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "IBM Cloud Essentials",
      subtitle: "- IBM Developer skill network",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/5aed944c-1084-4100-981a-cabc1e87bc94?source=linked_in_profile",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Deep Learning using TensorFlow",
      subtitle: "- IBM Developer skill network",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/daae5194-b88c-49dd-8db7-6934e188fa67?source=linked_in_profile",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Cloud Core",
      subtitle: "- IBM Developer skill network",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/003cc8e2-f4ea-4139-b74d-34df493f20bc?source=linked_in_profile",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Intermediate Machine Learning",
      subtitle: "- IBM Developer skill network",
      logo_path: "Kaggle_logo.png",
      certificate_link:
        "https://www.kaggle.com/learn/certification/sankalpsrivastava26/intermediate-machine-learning ",
      alt_name: "IBM",
      color_code: "rgb(223 222 255 / 60%)",
    },
    {
      title: "GCP Big Data and Machine Learning Fundamentals",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/E5NF8FYW74VT",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description: "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      experiences: [
        {
          title: "Full Stack Developer Intern",
          company: "ContractFlo",
          company_url: "https://www.contractflo.com/",
          logo_path: "LogoV3NoWhite.svg",
          duration: "May 2022 - Present",
          location: "Work From Home",
          description:
            "I have worked in building various componets in company's website using MERN stack and serveral APIs. I used different algorithms to make better and optimized solutions. I worked with libraries like ReactFlow, Material UI, Dagre, Firebase, Lodash, React quill etc and used Git for version control",
          description2:
            '"Feedback from Employer : Sankalp is incredibly smart and hardworking. He also puts in his own ideas, which is very special. Highly recommended."- Gaurav Palmar (Founder, ContractFlo)',
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Mentor in Open Source Program",
          company: "Social Summer of Code",
          company_url: "https://ssoc.devfolio.co/",
          logo_path: "social.jpg",
          duration: "August 2022 - Present",
          location: "Online",
          description:
            "Mentoring new open souce contributors and guiding them through their way.",
          color: "#4285F4",
        },
        {
          title: "Open source contributor",
          company: "Script Winter of Code",
          company_url: "https://swoc.scriptindia.org",
          logo_path: "swoc.jpg",
          duration: "December 2021 - February 2022",
          location: "Online",
          description:
            "Contributed in Project : ML-Crate. The  project will be the hub of various ML projects which will be the resources for the ML enthusiasts, Contributed 13 ML projects: Credit Card Fraud Detection | Character Recognition | Iris Classification | Caption Generation from Images | Banknote Dataset | Avocado Prices | Air Quality Prediction | Concrete Strength Calculation | Netflix Movies and Shows Analysis | Sonar Dataset Analysis |Classify the Emoji | Amazon Alexa Reviews Analysis  | Amazon Books Analysis ,Worked with Linear Regression, Logistic Regression, KNN, Random Forest, XGBoost, LightGBM and SVM algorithms",
          color: "#4285F4",
        },
        {
          title: "Open source contributor",
          company: "GirlScript Summer of Code",
          company_url: "https://gssoc.girlscript.tech/",
          logo_path: "gsoc.jpg",
          duration: "March 2021 - May 2021",
          location: "Online",
          description:
            "Contributed in Project : Breast Cancer Predictor. Aim of the project was to predict if a breast cancer is Malignant or Benign using Image Dataset as well as Numerical Data, Apply ML and DL Models to predict the severity of the Breast-Cancer. Create a Wonderful UI for this project using Front End Languages and Frameworks (Like Bootstrap), Create the Backend using Flask Framework.Deploy on Cloud and make this wonderful project available to public",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "",
  description: "",
  avatar_image_path: "",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "developerActivity.svg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Node and Opensource Development.",
  },
  blogSection: {
    title: "",
    subtitle: "",
    link: "",
    avatar_image_path: "",
  },
  addressSection: {
    title: "Address",
    subtitle: "Mahmoorganj, Varanasi, Uttar Pradesh - 221010",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/YJvvCJEeqpcwKroY8",
  },
  phoneSection: {
    title: "Email ID",
    subtitle: "raunaksrivastava22@gmail.com",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
